export default __webpack_public_path__ + "img/206a89d249508c1234fcd777f6328df6.svg";